/* tslint:disable */
/* eslint-disable */
export enum DeliveryType {
  Pickup = 'PICKUP',
  Delivery = 'DELIVERY',
  Eatin = 'EATIN'
}
